export default __webpack_public_path__ + "static/media/yardi.2b569845.png";